import Toggles from './Toggles.jsx';

export default Toggles;
